// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1k5uF","housemateData":"style_housemateData__158vM","cardImg":"style_cardImg__18NZv","text":"style_text__a3eHY","heading":"style_heading__3FkM9"};